module.exports = __webpack_public_path__ + "img/staff_avatar.62ea76c6.svg";